import React from 'react';
import Logo from './../../images/logo.png';

const TopLogo = ({ removePositioning, customStyles }) => {
  return (
    <img
      style={{
        height: '4rem',
        position: 'relative',
        top: removePositioning ? 0 : '1.5rem',
        ...customStyles
      }}
      src={Logo}
      alt="Yugbodh Logo"
    />
  );
};

export default TopLogo;
